import styles from './Message.module.css';
import hum from '../../assets/images/hum.jpg';
import { hideNumber } from '../../helpers/titreHelper';
import { iconsSources } from '../../helpers/icons';

const Message = ({ message, currentState, winId, user }) => {
  const [name, surname] = message?.author?.trim()?.split(' ');

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const avatar = message?.image?.includes(`${user}_${message.channel}`)
    ? iconsSources[message?.channel]
    : (message?.image !== '1' && message?.image) ||
      iconsSources[message?.channel] ||
      hum;

  return (
    <div className={styles['wrapper']}>
      {message && (
        <div className={`${styles['blockMsg']}`}>
          <div className={styles.avatarBlock}>
            <div
              className={styles.avatarBg}
              style={{
                background: `url(${
                  iconsSources[message?.channel]
                }) center/cover no-repeat `,
              }}
            />
            <img
              className={styles.avatar}
              src={avatar}
              alt=""
              onError={errorHandler}
            />
          </div>

          <div
            className={`${styles['nameAuthor']} ${
              winId === message.id && currentState === 'S8'
                ? styles['winnerBg']
                : ''
            }`}
          >
            {message?.author
              ? `${name} ${surname ? `${surname.slice(0, 1)}.` : ''}`
              : hideNumber(message?.senderNumber)}
          </div>
        </div>
      )}
    </div>
  );
};

export default Message;
